import { Badge } from "antd";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addRouterListener, getSearchFromUrl } from "../../../util/library/Router";
import { selectPermission } from "../../../util/store/selectors";
import { AppState } from "../../../util/store/store";
import { CHAT_TYPE, tabMessages } from '../../../util/varibles/constants';
import { ACTION } from "../../../util/varibles/permission";
import Chat from "../_component/Chat";
import Operation from "../_component/Operation";
import { messageActions } from "../reducer";
import stylesPage from "../style.module.scss";
import styles from "./style.module.scss";

const contentView: Record<string, React.FC<{ chatId: string, clearId(): void, }>> = {
    [CHAT_TYPE.USER]: Chat,
    [CHAT_TYPE.OPERATION]: Operation,
}

const mapStateToProps = (state: AppState) => {
    const { chatNew, operationsNew } = state.message
    return {
        count: { chatNew, operationsNew },
        permissions: selectPermission(state),
    }
}

interface IProps {
    count: any
    permissions: any

    getMessages(payload: any): void
}

class WrapperMessage extends Component<IProps> {
    state = {
        tab: CHAT_TYPE.USER,
        id: ''
    }

    listen: any;

    constructor(props: IProps) {
        super(props);

        const search = getSearchFromUrl();
        this.getState(search, (values: any) => this.setState(values))

        this.listen = addRouterListener((state) => {
            const search = getSearchFromUrl(state)
            this.getState(search, (values: any) => this.setState({ ...values }))
        })
    }

    componentWillUnmount() {
        if (this.listen)
            this.listen()
    }

    getState = (params: string[], action: any) => {
        const keys = new Set(['chatType', 'id']);
        const values: any = {};
        params.forEach((item: string) => {
            keys.forEach((key) => {
                if (item.indexOf(key) === 0) {
                    keys.delete(key);
                    values[key] = item.slice(key.length + 1);
                }
            })
        })

        if (keys.size === 0) {
            const { chatType, id } = values;
            action({ tab: chatType, id });
            this.props.getMessages({ id, index: 1 });
        }
    }

    render() {
        const { count, permissions } = this.props;
        const { tab, id } = this.state;

        const actions = {
            [CHAT_TYPE.USER]: ACTION.MESSENGER.USER,
            [CHAT_TYPE.OPERATION]: ACTION.MESSENGER.OPERATION,
        }

        return <div className={styles.wrapper}>
            <div className={stylesPage.sidebar}>
                {tabMessages.map((item) => {
                    if (!permissions[actions[item.id]])
                        return null;
                    return <div
                        key={item.id}
                        className={stylesPage.section}
                        data-actived={item.id === tab}
                        onClick={() => item.id === tab ? null : this.setState({ tab: item.id })}
                    >
                        <Badge className={stylesPage.badge} count={count[item.keyNew]} offset={[6, 1]}
                            overflowCount={99}>
                            <div className={stylesPage[item.icon]} />
                        </Badge>
                        <div data-lev='name'>{item.name}</div>
                    </div>
                })}
            </div>

            <div className={styles.messages}>
                {tabMessages.map(item => {
                    const { [item.id]: Content } = contentView;
                    if (!permissions[actions[item.id]])
                        return null;

                    return <div key={item.id} className={styles.section} data-actived={item.id === tab}>
                        <Content chatId={id} clearId={() => this.setState({ id: '' })} />
                    </div>
                })}
            </div>
        </div>;
    }
}

export default connect(mapStateToProps, {
    getMessages: messageActions.getMessagesRequest
})(WrapperMessage);
